<template>
	<div>
		<modalconfirm supplier ref="modalCreatePDO" @action="buatPDO"></modalconfirm>
		<div class="text-h5">Tambah Pengiriman Pemesanan</div>
		<v-card class="mt-3" outlined>
			<v-card-text>
				<v-alert v-for="(alert, index) in alertMultiple" v-model="alert.show" :key="index" dismissible type="error" elevation="1">
					{{alert.message}}
				</v-alert>
				<v-form>
					<v-row>
						<v-col cols="12" md="4">
							<v-row>
								<v-col cols="12" class="py-0">
									<v-autocomplete :items="listPO" v-model="po_selected" item-text="po_code" label="Kode Penjualan" return-object no-data-text="Tidak ada data yang sesuai" outlined dense color="cyan darken-2" item-color="cyan darken-2" :filter="customFilter" :error-messages="responseError.po_id" @focus="responseError.po_id = ''">
										<template v-slot:item = {item}>
											{{item.po_code}} - {{item.warehouse_name}}
										</template>
										<template v-slot:selection = {item}>
											{{item.po_code}}
										</template>
									</v-autocomplete>
								</v-col>
								<v-col cols="12" class="py-0" v-show="po_selected">
									<v-autocomplete :items="listSchedule" v-model="schedule_selected" item-text="po_schedule_detail_date" label="Jadwal Pengiriman" return-object no-data-text="Tidak ada data yang sesuai" outlined dense color="cyan darken-2" item-color="cyan darken-2" :filter="customFilter" :error-messages="responseError.po_id" @focus="responseError.po_schedule_detail_id = ''">
										<template v-slot:item = {item}>
											{{item.po_schedule_detail_date | tanggalIna }}
										</template>
										<template v-slot:selection = {item}>
											{{item.po_schedule_detail_date | tanggalIna }}
										</template>
									</v-autocomplete>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" md="4">
							<v-row>
								<v-col cols="12" class="py-0">
									<v-menu v-model="menu" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
										<template v-slot:activator="{ on, attrs }">
											<v-text-field :value="convertDate(est_sent_date)" label="Estimasi Kirim" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined dense color="cyan darken-2" :error-messages="responseError.estimated_sent_date" @focus="responseError.estimated_sent_date = ''"></v-text-field>
										</template>
										<v-date-picker color="cyan darken-2" @input="menu = false" v-model="est_sent_date" locale="id"></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="12" class="py-0">
									<v-menu v-model="menu2" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
										<template v-slot:activator="{ on, attrs }">
											<v-text-field :value="convertDate(est_received_date)" label="Estimasi Terima" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined dense color="cyan darken-2" :error-messages="responseError.estimated_received_date" @focus="responseError.estimated_received_date = ''"></v-text-field>
										</template>
										<v-date-picker color="cyan darken-2" @input="menu2 = false" v-model="est_received_date" locale="id"></v-date-picker>
									</v-menu>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" md="4">
							<v-textarea v-model="note" label="Catatan" outlined dense color="cyan darken-2" height="106" no-resize :error-messages="responseError.note" @focus="responseError.note = ''"></v-textarea>
						</v-col>
						<v-col cols="12" class="pt-0">
							<v-data-table disable-pagination :headers="headers" :items="productToDeliver" hide-default-footer class="mt-2 white-row" no-data-text="Belum ada data tersedia">
								<template v-slot:item.product_name="{ item }">
									<div class="pt-2">{{ item.po_detail_product_name }}</div>
								</template>
								<template v-slot:item.product_code="{ item }">
									<div class="pt-2">{{ item.po_detail_product_code }}</div>
								</template>
								<template v-slot:item.po_detail_quantity_approved="{ item }">
									<div class="pt-2">{{ item.po_schedule_detail_quantity | toNumber }}</div>
								</template>
								<template v-slot:no-data>
									<div>Tidak ada data yang dapat ditampilkan</div>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions class="px-3 pb-3">
				<v-spacer></v-spacer>
				<v-btn color="cyan darken-2" :disabled="!schedule_selected" depressed class="text-capitalize" dark @click="proccessKirim">Proses</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapGetters, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	data() {
		return {
			menu: false,
			menu2: false,
			list_payment: ['Lunas', 'Tempo'],
			po_selected: '',
			schedule_selected: '',
			est_sent_date: '',
			est_received_date: '',
			note: '',
			headers: [
			{ text: 'Nama Produk', align: 'start', value: 'supplier_product_name', sortable: true},
			{ text: 'Kode Produk', value: 'supplier_product_code', sortable: false},
			{ text: 'Jumlah', value: 'po_schedule_detail_quantity', align: 'center'},
			],
		}
	},
	props: {
	},
	computed: {
		...mapState('poSupplier', ['listPO']),
		...mapState('pdoSupplier', ['response', 'responseError', 'listSchedule', 'detailPO', 'alertMultiple']),
		...mapGetters('poSupplier', ['productPDO']),

		productToDeliver() {
			let product = []
			if (this.detailPO.po_schedules) {
				product = this.detailPO.po_schedules
			}
			return product
		}
	},
	methods: {
		...mapActions('poSupplier', ['getPOforPDO', 'getDetailPO']),
		...mapActions('pdoSupplier', ['createPDO', 'getSchedule', 'getScheduleByDate']),
		...mapMutations('poSupplier', ['clearDataPO']),
		...mapMutations('pdoSupplier', ['saveResponse', 'clearDataPDO', 'setSchedule', 'setScheduleByDate']),
		...mapMutations(['setOverlay']),

		deletefromPO(idProduct) {
			const indexProduct = this.supplierProducts.findIndex(el => el.product_id == idProduct)
			this.supplierProducts[indexProduct].selected = false
		},
		proccessKirim(){
			let msg = "Yakin akan memproses Pengiriman ini?"
			this.$refs.modalCreatePDO.setMessage(msg)
			this.$refs.modalCreatePDO.showConfirm()
		},
		async buatPDO() {
			await this.setOverlay(true)
			await this.$refs.modalCreatePDO.hideConfirm()
			let product = await this.productToDeliver.map( (el) => {
				return {
					product_id : el.po_detail_product_id,
					product_name : el.po_detail_product_name,
					quantity : el.po_schedule_detail_quantity
				}
			})
			let params = await {
				po_id: this.detailPO.po_id,
				estimated_sent_date: this.est_sent_date,
				estimated_received_date: this.est_received_date,
				schedule: this.schedule_selected.po_schedule_detail_date,
				note: this.note,
				product: product
			}
			await this.createPDO(params).then(() => {
				if (this.response.code == 200) {
					this.resetForm()
					this.getPOforPDO({limit: 100})
				}
			})
			await this.setOverlay(false)
		},
		resetForm() {
			this.saveResponse({
				code: '',
				message: ''
			})
			this.setScheduleByDate({})
			this.po_selected = ''
			this.schedule_selected = ''
			this.est_sent_date = ''
			this.est_received_date = ''
			this.note = ''
		},
		customFilter(item, queryText) {
			const textOne = item.po_code.toLowerCase()
			const textTwo = item.warehouse_name.toLowerCase()
			const searchText = queryText.toLowerCase()

			return textOne.indexOf(searchText) > -1 ||
			textTwo.indexOf(searchText) > -1
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Tambah Pengiriman`);
		this.getPOforPDO({limit: 100})
	},
	beforeDestroy() {
		this.clearDataPDO()
		this.clearDataPO()
	},
	watch: {
		po_selected(val) {
			this.schedule_selected = ''
			this.setScheduleByDate({})
			this.setSchedule([])
			if (val.po_code) {
				this.getSchedule(val.po_code)
			}
		},
		schedule_selected(val) {
			this.setScheduleByDate({})
			if (val.po_schedule_detail_date) {
				this.getScheduleByDate({po_code: this.po_selected.po_code, po_schedule_detail_date: val.po_schedule_detail_date})
			}
		}
	}
}
</script>